// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

import React from 'react';
import EquipmentDocs from '../site-sections/EquipmentDocs';
import { PageHead } from '../../components/shell/ScreenHelpers';

/**
 * Site → Knowledge Base. The mock's "Knowledge Base" (SOP/equipment Q&A) maps
 * to our existing Equipment Docs RAG surface (equipmentDocsService). Reused
 * as-is inside the Carbon shell page.
 */
export default function SiteKnowledgeBase() {
  return (
    <div className="hs-page">
      <PageHead title="Knowledge Base" dateline="Ask the equipment & SOP knowledge base" />
      <EquipmentDocs />
    </div>
  );
}
